<template>
	<header class="header">
		<a href="#" class="nav-btn" @click="visibleSider = true" style="z-index: 999999;">
			<span></span>
			<span></span>
			<span></span>
		</a>
		<div class="top-panel">
			<div class="">
				<div class="top-panel-cover">
					<ul class="header-cont">
						<li></li>
						<li></li>
					</ul>
					<ul class="icon-right-list">
						<li><span style="font-size: 16px;">Siguenos: </span></li>
						<li>
							<a href="https://wa.me/3315874072"><i class="pi pi-whatsapp iconpi"></i></a>
						</li>
						<li>
							<a href="https://www.facebook.com/proveedorferreterogdl" target="_blank"><i class="pi pi-facebook iconpi" style=""></i></a>
						</li>
						<li>
							<a href="https://www.instagram.com/proveedorferreterogdl" target="_blank"><i class="pi pi-instagram iconpi" ></i></a>
						</li>
						<li>
							<a href="https://www.youtube.com/@proveedorferreterogdl"><i class="pi pi-youtube iconpi" ></i></a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<Divider type="solid"/>
		<div class="header-menu">
			<div class="container">
				<router-link to="/" class="logo"><img loading="lazy" src="../assets/img/logo.svg" alt="logo" style="width: 200px;"></router-link>
				<div class="input-group mt-2" style="width: 60%;">
					<input type="text" class="form-control" style="width: 60%;" @keyup.enter="searchP()" placeholder="Buscar" aria-label="Buscar" aria-describedby="basic-addon2" v-model="searchProduct">
					<span @click="searchP()" class="input-group-text pi pi-search btn-search" id="basic-addon2" style=" cursor: pointer; height: 50px; display: flex; align-items: center; font-size: 1.5rem;"></span>
				</div>
				<nav class="nav-menu"  v-show="screenWidth > 768">
					<ul class="nav-list">
						<li>
							<!--i class="pi pi-user user-icon" style="cursor: pointer;" @click="profileLog"></i-->
						</li>
						<li>
                            <i class="pi pi-shopping-cart user-icon" style="cursor: pointer;" @click="siderCart = true" v-badge="cantCart" v-show="cantCart > 0"/>
							<i class="pi pi-shopping-cart user-icon" style="cursor: pointer;" @click="siderCart = true" v-show="cantCart < 1"/>
						</li>
					</ul>
				</nav>
			</div>
			<div style="justify-content: end; background: #000; display: flex; height: 38px; align-items: center;" v-show="screenWidth > 768">
				<nav class="nav-menu" style="padding-right: 20px;">
					<ul class="nav-list">
						
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/">Inicio</router-link></li>
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/nosotros">NOSOTROS</router-link></li>
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/tienda">PRODUCTOS</router-link></li>
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/catalogos">CATáLOGOS</router-link></li>
						<li class="dropdown">
							<a href="#">Apartados<i class="fa fa-angle-down" aria-hidden="true"></i></a>
							<ul>
								<li><router-link to="/faq">Preguntas frecuentes</router-link></li>
								<li><router-link to="/blog">Blog</router-link></li>
							</ul>
						</li>
						<li><router-link to="/contacto">Contácto</router-link></li>
					</ul>
				</nav>
			</div>
		</div>
	</header>
    <header class="header-fixed" v-show="scrollTop > 1">
		<a href="#" class="nav-btn" @click="visibleSider = true" style="z-index: 999999;">
			<span></span>
			<span></span>
			<span></span>
		</a>
		<div class="top-panel">
			<div class="">
				<div class="top-panel-cover">
					<ul class="header-cont">
						<li></li>
						<li></li>
					</ul>
					<ul class="icon-right-list">
						<li><span style="font-size: 16px;">Siguenos: </span></li>
						<li>
							<a href="https://wa.me/3315874072"><i class="pi pi-whatsapp iconpi"></i></a>
						</li>
						<li>
							<a href="https://www.facebook.com/proveedorferreterogdl" target="_blank"><i class="pi pi-facebook iconpi" style=""></i></a>
						</li>
						<li>
							<a href="https://www.instagram.com/proveedorferreterogdl" target="_blank"><i class="pi pi-instagram iconpi" ></i></a>
						</li>
						<li>
							<a href="https://www.youtube.com/@proveedorferreterogdl"><i class="pi pi-youtube iconpi" ></i></a>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<Divider type="solid"/>
		<div class="header-menu">
			<div class="container">
				<router-link to="/" class="logo"><img loading="lazy" src="../assets/img/logo.svg" alt="Proveedor Ferretero de Guadalajara" style="width: 200px;"></router-link>
				<div class="input-group mt-2" style="width: 60%;">
					<input type="text" @keyup.enter="searchP()" class="form-control" style="width: 60%;" placeholder="Buscar" aria-label="Buscar" aria-describedby="basic-addon2" v-model="searchProduct">
					<span @click="searchP()" class="input-group-text pi pi-search btn-search" id="basic-addon2" style=" cursor: pointer; height: 50px; display: flex; align-items: center; font-size: 1.5rem;"></span>
				</div>
				
				<nav class="nav-menu"  v-show="screenWidth > 768">
					<ul class="nav-list">
						<li>
							<i class="pi pi-user user-icon" style="cursor: pointer;" @click="profileLog"></i>
						</li>
						<li>
                            <i class="pi pi-shopping-cart user-icon" style="cursor: pointer;" @click="siderCart = true" v-badge="cantCart" v-show="cantCart > 0"/>
							<i class="pi pi-shopping-cart user-icon" style="cursor: pointer;" @click="siderCart = true" v-show="cantCart < 1"/>
						</li>
					</ul>
				</nav>
			</div>
			<div style="justify-content: end; background: #000; display: flex; height: 38px; align-items: center;" v-show="screenWidth > 768">
				<nav class="nav-menu" style="padding-right: 20px;">
					<ul class="nav-list">
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/">Inicio</router-link></li>
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/nosotros">NOSOTROS</router-link></li>
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/tienda">PRODUCTOS</router-link></li>
						<li><router-link @click="toUp" class="fa fa-angle-down" to="/catalogos">CATáLOGOS</router-link></li>
						<li class="dropdown">
							<a href="#">Apartados<i class="fa fa-angle-down" aria-hidden="true"></i></a>
							<ul>
								<li style="font-family: Verdana;"><router-link to="/faq" >Preguntas frecuentes</router-link></li>
								<li><router-link to="/blog">Blog</router-link></li>
							</ul>
						</li>
						<li><router-link to="/contacto">Contácto</router-link></li>
					</ul>
				</nav>
			</div>
		</div>
	</header>
    <Sidebar v-model:visible="siderCart" header="Right Sidebar" position="right" :showCloseIcon="false">
		<div class="containerCart">
			<center><h4 class="mb-4">Carrito</h4></center>
			<div v-show="cantCart>0">
				<ScrollPanel style="width: 98%; max-height: 65vh; min-height: 40%">
					<div v-for="(item, index) in productCart" style="width: 100%;" class="mb-2">
						<p class="text-center">{{ item.title }}</p>
						<img loading="lazy" :src="item.image" :alt="item.alt" style="width: 80%;" onerror="this.src='https://raw.githubusercontent.com/Proveedorferreterogdl/images/main/static/Images/productos/noencontrado/noencontrado.webp'">
						<p><strong>Modelo:</strong> {{ item.brand }} {{ item.model }}</p>
						<p> </p>
						<div class="row">
							<div class="col-4">
								<strong>Cant:</strong> {{ item.quantity }}
							</div>
							<div class="col-8" v-if="false">
								<p class="text-end">
									<strong>Costo:</strong> ${{ (item.cost).toFixed(2) }} MXN
								</p>
							</div>
						</div>
						<Divider type="solid"/>
					</div>
				</ScrollPanel>
				<div style="border-top: 1px solid #777777; width: 98%;">
					<table style="width: 98%;" v-if="false">
						<tr>
							<td><strong>Subtotal:</strong></td>
							<td class="cost-rigth">${{ (subtotalCart).toLocaleString('es-MX',{minimumFractionDigits: 2,maximumFractionDigits: 2,}) }} MXN </td>
						</tr>
						<tr>
							<td><strong>IVA:</strong></td>
							<td class="cost-rigth">${{ (subtotalCart * 0.16).toLocaleString('es-MX',{minimumFractionDigits: 2,maximumFractionDigits: 2,}) }} MXN</td>
						</tr>
						<tr>
							<td><strong>Total:</strong></td>
							<td class="cost-rigth">${{ (subtotalCart * 1.16).toLocaleString('es-MX',{minimumFractionDigits: 2,maximumFractionDigits: 2,}) }} MXN</td>
						</tr>
					</table>
					<button
						class="btnGen mt-2"
						style="width: 100%;"
						@click="goToCart()"
					>
					Ir al carrito
					</button>
				</div>
			</div>
			<div class="row" v-show="cantCart <= 0" style="width: 98%;">
				<div class="col">
					<h5 style="text-align: center;">No hay productos en el carrito</h5>
					<img loading="lazy" src="../assets/img/pedro_triste.png" alt="PFG" style="width: 80%;">
				</div>
			</div>
		</div>
	</Sidebar>
	<div v-show="screenWidth < 768" style="">
		<Sidebar v-model:visible="visibleSider" header="Right Sidebar" position="right" :showCloseIcon="false">
			<template #container="{ closeCallback }">
				<div class="flex flex-column h-full">
					<div class="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0">
						<span class="inline-flex align-items-center gap-2">
							<svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="..." fill="var(--primary-color-color)" />
								<path d="..." fill="var(--text-color)" />
							</svg>
							<span class="font-semibold text-2xl text-primary"><img loading="lazy" src="../assets/img/logo.svg" alt="PFG" style=""/></span>
						</span>
						<span>
							<i class="pi pi-times" @click="visibleSider = false" style="cursor: pointer; font-size: 2rem"></i>
						</span>
					</div>
					<div class="overflow-y-auto">
						<ul class="list-none p-3 m-0" style="font-family: 'Roboto Black'">
							<li>
								<div
									v-ripple
									v-styleclass="{
										selector: '@next',
										enterClass: 'hidden',
										enterActiveClass: 'slidedown',
										leaveToClass: 'hidden',
										leaveActiveClass: 'slideup'
									}"
									class="p-3 flex align-items-center justify-content-between text-600 cursor-pointer p-ripple"
								>
									<span class="font-medium">MENÚ</span>
									<i class="pi pi-chevron-down"></i>
								</div>
								<ul class="list-none p-0 m-0 overflow-hidden">
									<li>
										<router-link @click="toUp" to="/" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
											<i class="pi pi-home mr-2"></i>
											<span class="font-medium">Inicio</span>
										</router-link>
									</li>
									<li>
										<router-link @click="toUp" to="/nosotros" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
											<i class="pi pi-users mr-2"></i>
											<span class="font-medium">Nosotros</span>
										</router-link>
									</li>
									<li>
										<router-link @click="toUp" to="/tienda" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
											<i class="pi pi-box mr-2"></i>
											<span class="font-medium">Productos</span>
										</router-link>
									</li>
									<li>
										<router-link @click="toUp" to="/catalogos" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
											<i class="pi pi-book mr-2"></i>
											<span class="font-medium">Catálogos</span>
										</router-link>
									</li>
									<li>
										<a
											v-ripple
											v-styleclass="{
												selector: '@next',
												enterClass: 'hidden',
												enterActiveClass: 'slidedown',
												leaveToClass: 'hidden',
												leaveActiveClass: 'slideup'
											}"
											class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple"
										>
											<i class="pi pi-list mr-2"></i>
											<span class="font-medium">Apartados</span>
											<i class="pi pi-chevron-down ml-auto"></i>
										</a>
										<ul class="list-none py-0 pl-3 pr-0 m-0 hidden overflow-y-hidden transition-all transition-duration-400 transition-ease-in-out">
											<li>
												<router-link @click="toUp" to="/faq" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
													<i class="pi pi-question mr-2"></i>
													<span class="font-medium">Preguntas frecuentes</span>
												</router-link>
											</li>
											<li>
												<router-link @click="toUp" to="/blog" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
													<i class="pi pi-briefcase mr-2"></i>
													<span class="font-medium">Blog</span>
												</router-link>
											</li>
										</ul>
									</li>
									<li>
										<router-link @click="toUp" to="/contacto" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
											<i class="pi pi-phone mr-2"></i>
											<span class="font-medium">Contácto</span>
										</router-link>
									</li>
									<li>
										<router-link @click="toUp" to="/carrito" v-ripple class="flex align-items-center cursor-pointer p-3 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
											<i class="pi pi-shopping-cart mr-2"></i>
											<span class="font-medium">Carrito</span>
											<span v-show="cantCart >= 1" class="inline-flex align-items-center justify-content-center ml-auto bg-primary border-circle" style="min-width: 1.5rem; height: 1.5rem">{{ cantCart }}</span>
										</router-link>
									</li>
								</ul>
							</li>
						</ul>
					</div>
					<div class="mt-auto">
						<hr class="mb-3 mx-3 border-top-1 border-none surface-border" />
						<a @click="profileLog" v-ripple class="m-3 flex align-items-center cursor-pointer p-3 gap-2 border-round text-700 hover:surface-100 transition-duration-150 transition-colors p-ripple">
							<img loading="lazy" src="data:image/png;base64,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" alt="PFG" style="width: 50px; height: 50px; border-radius: 25px;">
							<span class="font-bold">{{ nomUser }}</span>
						</a>
					</div>
				</div>
			</template>
		</Sidebar>
	</div>
</template>

<script>
import Swal from 'sweetalert2'
import ModalV from './ModalSV.vue';
import {ref, onMounted, onBeforeUnmount} from 'vue';
export default {
	name: 'MenuNav',
	components:{
		ModalV,
	}, 
	props: {
		msg: String,
	},
	data(){
		return{
			nomUser: 'Iniciar sesión',
			visibleSider: false,
			siderCart: false,
			showModal: '',
			sesionO: ref(),
			screenWidth: 0,
			screenHeight: 0,
			cantCart: 0,
			productCart: ref(),
			subtotalCart : 0,
			jproducts: ref(),
			jUser: {},
			scrollTop: 0,
			searchProduct: '',
			avatrimg: "https://clipart-library.com/new_gallery/98-986856_dice-icon-icon-50x50-px.png",
		}
	},
	mounted(){
		if (localStorage.jproducts) {//Verificamos que existe el objeto jproducts
			this.jproducts = localStorage.jproducts;
			this.$store.commit('setMyVariable', JSON.parse(this.jproducts));
		}
		if (localStorage.juserl) {//Verificamos que existe el objeto juserl
			this.jUser = localStorage.juserl;
			this.$store.commit('setMyVariable', JSON.parse(this.jUser));
		}
		this.updateScreenSize();
		window.addEventListener("resize", this.updateScreenSize);
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		goToCart(){
			this.toUp();
			this.$router.push('/carrito');
		},
		toUp(){//Mandar hasta arriba
			window.scrollTo(0, 0);
			this.siderCart = false;
			this.visibleSider = false;
		},
		updateScreenSize() {//Actualizar el tamaño de la pantalla
			this.screenWidth = window.innerWidth;
			this.screenHeight = window.innerHeight;
			//this.cantCart = (this.$store.getters.getProducts).length;
		},
		profileLog(){//Validar si inicia sesion 
			if((this.jUser).length > 0) this.$router.push({ path: '/perfil', replace: true })//Comparamos si existe un usuario iniciado
			else this.$router.push({ path: '/login', replace: true })//Sino manda a iniciar sesión
			this.toUp();
			//this.$refs.sesionO.profileLog(event);
		},
		searchP(){//Mandamos a busca 
			this.searchProduct = this.searchProduct.trim();
			if(this.searchProduct != ''){
				var nSearch = this.searchProduct.replace(/\//g, "+");
				console.log(nSearch);

				this.$router.push({ path: '/tienda/'+nSearch, replace: true })
				this.searchProduct = '';
			}
			
		},
		ocModal(valor) {this.showModal = valor;}, //Metodo para abir o cerrar modal y es también en donde el componente ModalV se comunica
		handleScroll() {
			this.scrollTop = window.scrollY || document.documentElement.scrollTop;
		}
	},
	computed: {
		
	},
	watch:{
		'$store.state.products': {
			handler(newValue, oldValue) {
				this.productCart = this.$store.getters.getProducts;//Solicitar los datos a la store 
				this.cantCart = (this.productCart ).length;
				this.subtotalCart = 0;
				for(var i = 0; i < this.cantCart; i++){
					this.subtotalCart = this.subtotalCart + (this.productCart[i].quantity * this.productCart[i].cost);
				}
			},
			deep: true, // Observa cambios en propiedades anidadas
			immediate: true, // Ejecuta el watcher inmediatamente al montar el componente
		},
	},
	beforeUnmount() {
    	// Limpiar el listener al desmontar el componente
		window.removeEventListener("resize", this.updateScreenSize);
	},

}
</script>

<style scoped>
.btn-search{
	transition: 0.5s;
}
.btn-search:hover{
	background-color: rgba(0, 0, 0, 0.863);
	border: 1px solid rgba(102, 102, 102, 0.863);
	color: #ffbf00;
}
.cost-rigth{
    text-align: end;
}
.containerCart{
	padding: 10px;
}
.container-menu{
	padding: 10px;
}
.header, .header-fixed{
	
	top: 0;
	left: 0;
	width: 100%;
	text-align: center;
	z-index: 1000;
}
.header-fixed{
	position:fixed;
}
.iconpi{
	color: rgb(0, 0, 0,0.7);
}
.iconpi:hover{
	color: rgba(70, 70, 70, 0.7);
}
.item-icons{
	list-style-type: none;
}
.btnis{
	width: 100%; 
	color: #000;
	display: flex;
	justify-content: center;
}
.btnis a:hover{
	color: #000;
}
.v-enter-active, .v-leave-active {
	transition: opacity 0.5s ease;
}

.v-enter-from, .v-leave-to {
	opacity: 0;
}

.input-container {
	display: flex;
	align-items: center;
}

.input-container span {
  padding: 0.5em; /* Ajusta el espaciado según tus necesidades */
}

.input-container input {
  flex: 1; /* El input toma el espacio restante */
}

.searchInput{
	border-radius: 10px;
	width: 200px;
}

.input-group {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	
}

.input-group i {
	font-size: 16px;
	margin-right: 10px;
	
}
.input-group input {
	width: 100%;
	padding: 10px;
	border: 1px solid rgba(0, 0, 0, 0.5);
	height: 50px;
	background: #fff;
}
</style>